import globals from '../../globals'

export default function staticPath(src: string) {
  return `${globals.static}${src}`
}
